import React from "react";
import Field from "./Field";
import NumberControl from "./NumberControl";
import { FieldProps } from "./Types";

const NumberField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <NumberControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default NumberField;